// Bug Report Button Module
export function initializeBugReport() {
    const bugReportBtn = document.createElement('button');
    bugReportBtn.className = 'bug-report-btn';
    bugReportBtn.innerHTML = `
        <i class="fas fa-bug"></i>
        <div class="bug-report-text">
            <span>Report Bug /</span>
            <span>Improvement</span>
        </div>
    `;
    
    bugReportBtn.addEventListener('click', () => {
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSdYVsImMLSdnrKNUTOGudhAu1JuMY4WipmtJ2C1vi0JGAO-ww/viewform?usp=dialog', '_blank');
    });
    
    document.body.appendChild(bugReportBtn);
} 